import { useFormik } from 'formik';
import { useEffect } from 'react';
import { Product } from '../../../../../../shared/types/systemConfiguration/products';

export const useProductRegisterHistory = (product?: Product) => {
    const formik = useFormik({
        initialValues: {
            createdBy: '',
            updatedBy: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const { createdBy, updatedBy } = product || {};
        formik.setValues({
            createdBy: createdBy
                ? `(${createdBy.username}) ${createdBy.name} ${createdBy.surname}`
                : '',
            updatedBy: updatedBy
                ? `(${updatedBy.username}) ${updatedBy.name} ${updatedBy.surname}`
                : '',
        });
    }, [product]);

    return {
        formik,
    };
};
